/** Mosaïque KPI dashboard (grille 2×2 — adapté Uiverse card). */

export type KpiMosaicItem = {
  id: string;
  title: string;
  /** SVG inline (viewBox 0 0 24 24, préférer currentColor) */
  iconSvg: string;
  /** Accent (icône, label, teinte de fond) */
  accent: string;
  /** Hash de navigation (ex. `#circuits`) */
  href?: string;
};

/** @deprecated alias — préférer KpiMosaicItem */
export type KpiStatCardOptions = KpiMosaicItem;

function escapeAttr(s: string): string {
  return s.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
}

function escapeHtml(s: string): string {
  const div = document.createElement('div');
  div.textContent = s;
  return div.innerHTML;
}

export function kpiMosaicHtml(items: readonly KpiMosaicItem[]): string {
  const cells = items
    .map((item, index) => {
      const inner = `
      <span class="kpi-mosaic__icon" aria-hidden="true">${item.iconSvg}</span>
      <span class="kpi-mosaic__quantity" data-kpi="${escapeAttr(item.id)}">—</span>
      <span class="kpi-mosaic__label">${escapeHtml(item.title)}</span>`;
      const className = `kpi-mosaic__item kpi-mosaic__item--${index + 1}`;
      const style = `--kpi-item-accent: ${escapeAttr(item.accent)}`;
      if (item.href) {
        return `
    <a
      href="${escapeAttr(item.href)}"
      class="${className}"
      data-kpi-card="${escapeAttr(item.id)}"
      style="${style}"
      aria-label="${escapeAttr(item.title)}"
    >${inner}
    </a>`;
      }
      return `
    <div
      class="${className}"
      data-kpi-card="${escapeAttr(item.id)}"
      style="${style}"
    >${inner}
    </div>`;
    })
    .join('');

  return `<div class="kpi-mosaic" role="group" aria-label="Statistiques">${cells}</div>`;
}

/** @deprecated — utilise kpiMosaicHtml avec un tableau */
export function kpiStatCardHtml(opts: KpiStatCardOptions): string {
  return kpiMosaicHtml([opts]);
}

export function updateKpiStatCards(root: ParentNode, values: Record<string, number>): void {
  for (const [key, val] of Object.entries(values)) {
    const valueEl = root.querySelector(`[data-kpi="${key}"]`);
    if (valueEl) valueEl.textContent = String(val);
  }
}
